import { ContactService, UserService } from "@/services";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

const CountDown = () =>
  import(/* webpackChunkName: "count-down" */ "@/components/CountDown/index");

import $enDigits from "@/mixins/enDigits";

export default {
  name: "phone",
  components: { CountDown },
  mixins: [$enDigits],
  data() {
    return {
      phoneInput: "",
      phoneCode: "",
      isPhoneHover: false,
      isPhoneFocus: false,
      isCountDownFinish: false,
      ttl: "",
      isRequesting: false,
      errorText: ""
    };
  },
  computed: {
    ...mapGetters({
      isModalOpen: types.phone.getters.IS_MODAL_OPEN,
      modalStep: types.phone.getters.MODAL_STEP,
      userInfo: types.userInfo.getters.GET_USER_INFO,
      userVerify: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),

    dialogHeight() {
      switch (this.modalStep) {
        case 1:
          return "height: 330px;";

        case 2:
          return "height: 420px;";
      }
    },

    isVerify() {
      return this.userVerify?.home_phone_verification_status === "VERIFIED";
    },

    phone() {
      return this.userInfo?.phone;
    },

    phoneModal: {
      get() {
        return this.isModalOpen;
      },
      set(val) {
        this.setModal(val);
      }
    },

    phoneNameClass() {
      if (this.isPhoneFocus) {
        return "mobile_name_focus";
      } else {
        if (!this.isPhoneValid) {
          return "mobile_name_error";
        } else {
          if (this.phoneInput) {
            return "mobile_name_fill";
          } else {
            if (this.isPhoneHover) {
              return "mobile_name_empty_hover";
            } else {
              return "mobile_name_empty";
            }
          }
        }
      }
    },

    isPhoneValid() {
      if (this.phoneInput) {
        const phoneRegex = /^(0[1-9]{2})[2-9][0-9]{7}$/;
        return phoneRegex.test(this.phoneInput);
      }
      return true;
    },

    isPhoneCodeValid() {
      if (this.phoneCode) {
        const phoneRegex = /^\d{1,6}$/;
        return phoneRegex.test(this.phoneCode);
      }
      return true;
    },
    isHomePhoneVerified() {
      return this.userVerify.is_home_phone_verified;
    },
    isHomePhoneSubmitted() {
      return this.userVerify.is_home_phone_submitted;
    }
  },
  mounted() {
    if (this.phone) {
      this.phoneInput = this.phone;
    }
  },
  methods: {
    ...mapActions({
      setStep: types.phone.actions.SET_STEP,
      setModal: types.phone.actions.SET_MODAL,
      setPhone: types.userVerifyInfo.actions.SET_PHONE_STATUS,
      setVerifyData: types.userVerifyInfo.actions.SET_USER_VERIFY_INFO,
      setUserData: types.userInfo.actions.ACTION_USER_INFO
    }),

    checkValidation() {
      this.errorText = "";
      if (this.phoneInput) {
        if (!this.isPhoneValid) {
          this.errorText = this.$t(
            "accountPage.identityInformation.contactInfo.phone.phoneValidation.invalid"
          );
        }
      } else {
        this.errorText = this.$t(
          "accountPage.identityInformation.contactInfo.phone.phoneValidation.empty"
        );
      }
    },

    startRequest() {
      this.isRequesting = true;
    },

    finishRequest() {
      this.isRequesting = false;
    },

    openModal() {
      this.setModal(true);
    },

    openModalStep1() {
      this.setStep(1);
      this.setModal(true);
    },

    // openModalStep2() {
    //   !this.isRequesting &&
    //     ContactService.activePhone(this.phone)
    //       .then(() => {
    //         this.setStep(2);
    //         this.setModal(true);
    //       })
    //       .finally(() => this.finishRequest());
    //   this.startRequest();
    // },

    closePhoneModal() {
      this.setModal(false);
    },

    setPhoneHover(bool) {
      this.isPhoneHover = bool;
    },

    togglePhoneFocus() {
      this.isPhoneFocus = !this.isPhoneFocus;
    },

    handleFinishCountDown() {
      this.isCountDownFinish = true;
      this.ttl = "";
    },

    resetCounter() {
      this.isCountDownFinish = false;
    },

    // activePhone() {
    //   this.checkValidation();
    //   if (this.phoneInput && this.isPhoneValid) {
    //     ContactService.activePhone(this.phoneInput)
    //       .then((res) => {
    //         this.ttl = res.data.data.ttl;
    //         this.resetCounter();
    //         this.setStep(2);
    //         this.closePhoneModal();
    //       })
    //       .finally(() => this.finishRequest());
    //     this.startRequest();
    //   }
    // },

    storePhone() {
      ContactService.storePhone(this.phoneInput)
        .then(res => {
          this.closePhoneModal();
          this.getAuthVerifyInfo();
          this.getUserInfo();
          this.$toast.success(res.data.message);
        })
        .finally(() => this.finishRequest());
    },
    getAuthVerifyInfo() {
      UserService.getVerifyInfo().then(response => {
        this.setVerifyData(response.data.data);
      });
    },
    getUserInfo() {
      UserService.getInfo().then(response => {
        this.setUserData(response.data.data);
      });
    },

    reActivePhone() {
      ContactService.activePhone(this.phoneInput)
        .then(res => {
          this.ttl = res.data.data.ttl;
          this.resetCounter();
        })
        .finally(() => this.finishRequest());
      this.startRequest();
    },

    verifyPhone() {
      if (this.isPhoneCodeValid) {
        ContactService.verifyPhone(this.phone)
          .then(res => {
            this.setPhone("VERIFIED");
            this.closePhoneModal();
            this.$toast.success(res.data.message);
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      }
    }
  },

  watch: {
    phoneInput(newValue, oldValue) {
      this.checkValidation();
      const value = this.$enDigits(newValue);
      this.phoneInput = value;
      const digitReg = /^\d+$/;
      const isDigit = digitReg.test(value);
      if (newValue) {
        if (!isDigit) {
          this.phoneInput = oldValue;
        }
      }
    },

    phoneCode(newValue, oldValue) {
      const value = this.$enDigits(newValue);
      this.phoneCode = value;
      const regex = /^\d+$/;
      const isCodeValid = regex.test(value);
      if (newValue) {
        if (!isCodeValid) {
          this.phoneCode = oldValue;
        }
      }
    }
  }
};
